import React, { useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaBell, FaCarSide, FaHome, FaUser } from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';

function MobileNavigation() {
  const { session, loading } = useContext(AuthContext);
  const location = useLocation();
  if (loading || session.roles.includes('GUEST')) return null;

  const items = [
    { to: '/dashboard', label: 'Home', icon: <FaHome />, match: section => !section },
    { to: '/dashboard?section=guestVehicles', label: 'Visitors', icon: <FaCarSide />, match: section => section === 'guestVehicles' },
    { to: '/dashboard?section=notice', label: 'Notices', icon: <FaBell />, match: section => section === 'notice' },
    { to: '/profile', label: 'Profile', icon: <FaUser />, match: () => location.pathname === '/profile' },
  ];
  const section = new URLSearchParams(location.search).get('section');

  return (
    <nav className="mobile-bottom-nav" aria-label="Resident navigation">
      {items.map(item => {
        const active = location.pathname === '/dashboard' ? item.match(section) : item.match();
        return <NavLink key={item.label} to={item.to} className={active ? 'is-active' : ''}><span>{item.icon}</span><small>{item.label}</small></NavLink>;
      })}
    </nav>
  );
}

export default MobileNavigation;
